import SuperAdminSidebar from "./SuperAdminSidebar.container";

export default SuperAdminSidebar;
